import { ProductEntity } from '../entities/product-entity';

export default class State {
  items: Array<ProductEntity> = [];

  loaded = false;
}
